import React from "react";

// SVG marker for Harnas, scaled to 7x12 px, stroke color is dynamic
const HarnasMarkerSVG = ({ x, y, stroke }) => (
  <g transform={`translate(${x - 6}, ${y - 6})`}>
    <svg
      width={12}
      height={12}
      viewBox="0 0 293.26 295.64"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: "block" }}
    >
      <polyline
        points="17 295.64 17 17 276.26 17 276.26 295.64"
        fill="none"
        stroke={stroke}
        strokeMiterlimit={10}
        strokeWidth={100}
      />
    </svg>
  </g>
);

export default HarnasMarkerSVG;
